/** Fills the client layout content slot below the pre-auth header (not another viewport). */
export const CLIENT_AUTH_PAGE_SHELL_CLASS =
  'flex min-h-0 flex-1 h-full w-full items-center justify-center overflow-hidden'

type AuthSpinnerSize = 'sm' | 'md'

const AUTH_SPINNER_SIZE_CLASS: Record<AuthSpinnerSize, string> = {
  sm: 'h-10 w-10',
  md: 'h-12 w-12',
}

/** Spinner for auth loading states; client portal uses fixed brand tokens, patient uses tenant CSS. */
export function getAuthSpinnerClass(isClientPortal: boolean, size: AuthSpinnerSize = 'md'): string {
  const borderClass = isClientPortal ? 'border-bright-blue' : 'border-tenant-primary-action-color'
  return `animate-spin rounded-full border-b-2 ${AUTH_SPINNER_SIZE_CLASS[size]} ${borderClass}`
}

/** Secondary status line under auth spinners (e.g. "Redirecting…"). */
export function getAuthStatusTextClass(isClientPortal: boolean): string {
  const colorClass = isClientPortal ? 'text-placeholder' : 'text-tenant-description-text'
  return `text-sm text-center ${colorClass}`
}
